import React, { type ComponentProps } from 'react';
import { InputLabel } from './InputLabel';
import { HelperText } from './HelperText';
import { Box, makeStyles } from 'vendor/material';
import SingleSelectInput from './SingleSelectInput';

const useStyles = makeStyles((theme) => ({
  label: {
    marginBottom: theme.typography.pxToRem(4),
  },
}));

interface SingleSelectProps {
  name: string;
  options: ComponentProps<typeof SingleSelectInput>['options'];
  label: string;
  errorMessage?: string;
  filterSelectedOptions?: boolean;
  tooltipText?: string;
  required?: boolean;
  dataId?: string;
  onChange: (value: SingleSelectProps['options'][number]['value']) => void;
  onBlur: ComponentProps<typeof SingleSelectInput>['onBlur'];
  placeholder?: ComponentProps<typeof SingleSelectInput>['placeholder'];
  helperText?: string;
}

type SingleSelectFieldProps = ComponentProps<typeof SingleSelectInput> &
  SingleSelectProps;

const SingleSelectField: React.FC<SingleSelectFieldProps> = ({
  disabled,
  label,
  options = [],
  tooltipText,
  required,
  dataId = null,
  name,
  onBlur,
  onChange,
  helperText,
  value,
  errorMessage,
  placeholder,
}) => {
  const classes = useStyles();
  const handleSingleSelectChange = (
    _event: React.SyntheticEvent<Element, Event>,
    selectedOption: SingleSelectFieldProps['options'][number],
  ) => {
    onChange(selectedOption?.value);
  };

  return (
    <Box>
      <InputLabel
        dataId={dataId}
        label={label}
        required={required}
        tooltipText={tooltipText}
        className={classes.label}
        name={name}
      />
      <SingleSelectInput
        dataId={dataId}
        disabled={disabled}
        errorMessage={errorMessage}
        name={name}
        onChange={handleSingleSelectChange}
        onBlur={onBlur}
        options={options}
        placeholder={placeholder}
        value={value}
      />
      <HelperText>{helperText}</HelperText>
    </Box>
  );
};

export default SingleSelectField;
